export default __webpack_public_path__ + "static/media/banner1.7716ea33.jpg";